import { render, staticRenderFns } from "./jobfair-info.vue?vue&type=template&id=1289d066&scoped=true"
import script from "./jobfair-info.vue?vue&type=script&lang=js"
export * from "./jobfair-info.vue?vue&type=script&lang=js"
import style0 from "./jobfair-info.vue?vue&type=style&index=0&id=1289d066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1289d066",
  null
  
)

export default component.exports